import { Route, Routes } from 'react-router-dom';
import { CreatePayment } from './CreatePayment';
import { PaymentHistory } from './PaymentHistory';

export const Payments = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<PaymentHistory />} />
        <Route path="/create" element={<CreatePayment />} />
      </Routes>
    </>
  );
};
